<script>
import store from '@state/store'
import { debounce } from 'debounce'
import { authComputed } from '@state/helpers'
import EventCalendar from '@events/components/event-calendar.vue'
import EventsList from '@events/components/events-list.vue'
import EventsParentMixin from '@events/mixins/events-parent-mixin'
import { isFuture, parseISO } from 'date-fns'

export default {
  name: 'EventsSidebar',
  components: { EventCalendar, EventsList },
  mixins: [EventsParentMixin],
  props: {
    companyId: {
      type: Number,
      required: false,
      default: null,
    },
    coHostOrganizationId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    events() {
      const events = this.$store.state.events.events
      if (!events || !Array.isArray(events)) return []
      return events.filter(
        ({ end, ongoing }) => isFuture(parseISO(end)) || ongoing
      )
    },
    ...authComputed,
  },
  mounted() {
    // Load events based on the context
    if (this.coHostOrganizationId) {
      store.dispatch('events/fetchFilteredEvents', {
        coHostOrganizationId: this.coHostOrganizationId,
        filters: {},
      })
    } else if (this.companyId) {
      store.dispatch('events/fetchFilteredEvents', {
        companyId: this.companyId,
        filters: {},
      })
    }
  },
  methods: {
    currentDate() {
      return this.$store.state.events.filters.from_date
    },
    // Call only every 500ms so we don't update imediatelly if the user is browsing
    updateMonth: debounce(async function updateMonth(date) {
      this.currentDate = date
      await store.dispatch('events/setFilterMonth', {
        companyId: this.companyId,
        coHostOrganizationId: this.coHostOrganizationId,
        monthDate: date,
      })
    }, 500),
  },
}
</script>

<template>
  <div class="w-5/12 right-events max-w-1md">
    <EventCalendar
      :events="events"
      :current-date="currentDate()"
      @previous="updateMonth"
      @next="updateMonth"
      @filter-between="filterBetweenDates"
    >
    </EventCalendar>
    <div v-if="!events">Loading...</div>
    <div v-else-if="!events.length">
      There are no events that match these search criteria.
    </div>
    <EventsList v-else :current-user-id="currentUserId" :events="events" />
  </div>
</template>
